import Accordion from 'react-bootstrap/Accordion';

export default function AccordionOne(){
    return(
        <>
        <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
                <Accordion.Header>What is your pricing strategy and why?</Accordion.Header>
                <Accordion.Body>
                <p>Key business questions are the questions that your data expert will be tasked
                        with answering. They are the questions have about business performance
                        that are central to the overall strategy.
                    </p>
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
                <Accordion.Header>Do you know anyone that works with our company?</Accordion.Header>
                <Accordion.Body>
                <p>Key business questions are the questions that your data expert will be tasked
                        with answering. They are the questions have about business performance
                        that are central to the overall strategy.
                    </p>
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
                <Accordion.Header>How do you prioritize your work?</Accordion.Header>
                <Accordion.Body>
                <p>Key business questions are the questions that your data expert will be tasked
                        with answering. They are the questions have about business performance
                        that are central to the overall strategy.
                    </p>
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
                <Accordion.Header>How do you prioritize your work?</Accordion.Header>
                <Accordion.Body>
                <p>Key business questions are the questions that your data expert will be tasked
                        with answering. They are the questions have about business performance
                        that are central to the overall strategy.
                    </p>
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
                <Accordion.Header>What is your pricing strategy and why?</Accordion.Header>
                <Accordion.Body>
                <p>Key business questions are the questions that your data expert will be tasked
                        with answering. They are the questions have about business performance
                        that are central to the overall strategy.
                    </p>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
        </>
    )
}